<script lang="ts">
  import { fly } from 'svelte/transition';
  import { linear } from 'svelte/easing';
  import { Button, Heading, Paragraph } from '..';
  import { moneyFormat } from '../../helpers/price-helper';
  import { browser } from '$app/environment';
  import type {
    GlobalProperties,
    UseFormattedProps,
    ItemsInModel,
  } from 'customer-components/lib/types';

  export let image: ItemsInModel['image'];
  export let heading: ItemsInModel['heading'];
  export let text: ItemsInModel['text'];
  export let button: ItemsInModel['button'];
  export let price: ItemsInModel['price'] = 0;
  export let imageSize: UseFormattedProps['imageSize'];
  export let cardStyle: UseFormattedProps['cardStyle'];
  export let alignment: UseFormattedProps['alignment'];
  export let borderRadius: GlobalProperties['borderRadius'];
  export let length: number = null;
  export let isSlide: UseFormattedProps['scroller'] = false;
  export let properties: UseFormattedProps;

  const options = { duration: 300, easing: linear };

  //Remove html tags from string with regex
  const stripHtml = html => {
    try {
      let tmp = document.createElement('DIV');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    } catch (e) {
      return html;
    }
  };
</script>

{#if length === 1 && cardStyle === 'card'}
  <div class="list-card single" style="text-align: {alignment};">
    <div class="flex-container">
      <div class="image">
        {#if image?.active}
          <img src={image.url} alt="" />
        {/if}
      </div>

      <div class="text">
        {#if heading.active}
          <Heading
            type={'h3'}
            css={`text-align:center; margin: 16px 0;${
              cardStyle === 'card' && 'color: black'
            }`}
          >
            {@html heading.value}
          </Heading>
        {/if}

        {#if text.active && browser}
          <div class="text-block text-align-center">
            <Paragraph
              css={`text-align:center;max-width:400px;${
                cardStyle === 'card' && 'color: black'
              }`}
            >
              {stripHtml(text?.value) || ''}
            </Paragraph>
          </div>
        {/if}

        {#if properties.showPrice && price}
          <div class="prices">
            <p class="service">Starting from</p>
            <p class="price">
              <span class="money">$</span>{moneyFormat(price)}
            </p>
          </div>
        {/if}

        {#if button.active}
          <Button
            {borderRadius}
            section="list card"
            buttonType={button.link_type}
            buttonLink={button.link}
            buttonTitle={button.label}
          />
        {/if}
      </div>
    </div>
  </div>
{:else}
  <div
    transition:fly={{ ...options, y: -10 }}
    class="list-card
        {cardStyle === 'card' ? 'bordered' : ''}
        {isSlide ? 'slide' : ''}"
    style="text-align: {alignment}"
  >
    {#if image?.active}
      <div
        class={cardStyle === 'card' ? 'card-image' : 'image-container'}
        style="display:inline-flex; width: {imageSize}%"
      >
        <img class="single-image" src={image.url} alt="" />
      </div>
    {/if}

    <div
      class="card-body {cardStyle === 'card' ? 'container' : ''}"
      style="text-align: {alignment}; height: {button.active ? '100%' : 'auto'}"
    >
      {#if heading.active}
        <Heading
          type={'h3'}
          css={`font-family: var(--vlt-lp-heading-font, 'DM Sans');text-align:center;margin-top:15px;${
            cardStyle === 'card' && 'color: black'
          }`}
        >
          {@html heading.value}
        </Heading>
      {/if}

      {#if text.active && browser}
        <div class="text-block">
          <Paragraph css={'text-align:center;max-width:400px;'}
            >{stripHtml(text?.value) || ''}</Paragraph
          >
        </div>
      {/if}

      {#if properties?.showPrice && price}
        <div class="prices">
          <p class="service">Starting from</p>
          <p class="price"><span class="money">$</span>{moneyFormat(price)}</p>
        </div>
      {/if}

      {#if button.active}
        <Button
          {borderRadius}
          section="list card"
          buttonType={button.link_type}
          buttonLink={button.link}
          buttonTitle={button.label}
        />
      {/if}
    </div>
  </div>
{/if}

<style>
  .prices {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #eaeaeb;
    padding-top: 20px;
    margin-bottom: 24px;
  }
  span.money {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 32px;
    margin-right: 2px;
  }
  p.service {
    margin: 0;
    padding: 0;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
    color: #0e0f11;
  }
  p.price {
    display: flex;
    align-items: flex-end;
    margin: 0;
    padding: 0;
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    color: #0e0f11;
  }
  .list-card {
    margin: 0 auto;
  }
  .list-card.slide {
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    justify-content: center;
    background-color: #ffffff;
    font-family: var(--vlt-lp-paragraph-font, 'DM Sans');
    max-width: 100%;
  }
  .list-card.bordered {
    display: flex;
    flex-direction: column;
    text-align: left;
    width: auto;
    flex: 1 1 305px;
    max-width: 450px;
    margin-bottom: 20px;
    margin-left: 10px;
    margin-right: 10px;
    border: 1px solid #ecebea;
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 6px 6px 10px 0 rgba(0, 0, 0, 0.08);
  }
  .list-card.bordered .text-block {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin: 0 auto;
    margin-bottom: 40px;
    color: #0e0f11;
    margin-top: 16px;
  }
  :global(.text-block p) {
    display: inline;
  }
  :global(.list-card.bordered .text-block p) {
    padding-bottom: 0;
    font-family: var(--vlt-lp-paragraph-font, 'DM Sans');
    color: #0e0f11;
  }
  .list-card.single {
    display: flex;
    flex-direction: column;
    text-align: left;
    max-width: 800px;
    width: 100%;
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid #ecebea;
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 6px 6px 10px 0 rgba(0, 0, 0, 0.08);
  }
  .single-image {
    width: 100% !important;
    height: auto !important;
  }
  .flex-container {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
  }
  .image {
    flex: 1;
    min-width: 300px;
    max-width: 400px;
    object-fit: cover;
    height: auto;
  }
  .text {
    flex: 2;
    text-align: left;
    min-width: 300px;
    color: #0e0f11;
  }
  .text .text-block {
    text-align: left;
    margin-bottom: 16px;
  }
  .list-card {
    width: 100%;
    flex: 1 1 260px;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    word-break: break-word;
    margin: 0 auto;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  p {
    padding-bottom: 20px;
    font-size: 16px;
    line-height: 28px;
  }

  .card-image {
    height: 200px;
  }
  .card-body {
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .card-body.container {
    padding: 24px;
  }
  .image-container {
    height: 270px;
  }

  .text-align-center {
    text-align: center;
  }
  @media screen and (max-width: 812px) {
    .image {
      min-width: 100%;
      height: 200px;
    }
    .text {
      min-width: 100%;
      margin-left: 0;
      margin-top: 20px;
    }
  }
  @media screen and (max-width: 960px) {
    .list-card.slide {
      flex: 1 1 340px !important;
      max-width: 100% !important;
    }
  }
  @media screen and (max-width: 720px) {
    .list-card.bordered {
      max-width: 100%;
    }
  }
  @media screen and (max-width: 768px) {
    .list-card.slide {
      max-width: 100%;
    }
    .list-card {
      flex: 1 1 400px;
    }
    .list-card.bordered {
      margin-left: 0;
      margin-right: 0;
    }
  }
</style>
